export const API_URL = "https://pameldinger.no/api/u";
//export const API_URL = "http://localhost:8000/api/u";
